/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Link,
} from '@mui/material';

class ModalComponent extends Component {
  render() {
    const { isOpen, onClose } = this.props;

    return (
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        <DialogTitle id="dialog-title">
          <strong>All Our Prices are VAT Inclusive</strong>
        </DialogTitle>
        <DialogContent>
          <Typography id="dialog-description" sx={{ mt: 2 }}>
            By law, from the 1st of January 2018, all goods and services sold will be charged 5% for
            VAT. This includes all, but not limited to, our vehicles, accessories, parts & services.
          </Typography>
          <Typography id="dialog-description" sx={{ mt: 2 }}>
            All our pricing displayed are inclusive of VAT since the 1st of January 2018. If
            you&apos;d like to know more about VAT, please visit{' '}
            <Link href="https://www.tax.gov.ae/">https://www.tax.gov.ae/</Link>.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default ModalComponent;
